import React from 'react';
import { Helmet } from 'react-helmet';
import MerchantDashboard from '../../components/merchant-dashbaord/merchant-dashboard.component';

const DashboardPage = () => {
  <Helmet>
    <title>XPAY.World - Merchant Dashboard</title>
  </Helmet>;
  return (
    <>
      <MerchantDashboard />
    </>
  );
};

export default DashboardPage;
